
const towMenu = {
  //基础数据管理
	user: require('@/common/images/icon/11.png'),
	user_active: require('@/common/images/icon/11_1.png'),
	menu: require('@/common/images/icon/12.png'),
	menu_active: require('@/common/images/icon/12_1.png'),
	organization: require('@/common/images/icon/13.png'),
	organization_active: require('@/common/images/icon/13_1.png'),
	role: require('@/common/images/icon/14.png'),
	role_active: require('@/common/images/icon/14_1.png'),
	journal: require('@/common/images/icon/15.png'),
	journal_active: require('@/common/images/icon/15_1.png'),
	dictionaries: require('@/common/images/icon/16.png'),
	dictionaries_active: require('@/common/images/icon/16_1.png'),
  //淤地坝基本情况
  essentialinformation: require('@/common/images/icon/21.png'),
  essentialinformation_active: require('@/common/images/icon/21_1.png'),
  register: require('@/common/images/icon/22.png'),
  register_active: require('@/common/images/icon/22_1.png'),
  dexam: require('@/common/images/icon/23.png'),
  dexam_active: require('@/common/images/icon/23_1.png'),
  yexam: require('@/common/images/icon/24.png'),
  yexam_active: require('@/common/images/icon/24_1.png'),
  reject: require('@/common/images/icon/25.png'),
  reject_active: require('@/common/images/icon/25_1.png'),
  personliable: require('@/common/images/icon/26.png'),
  personliable_active: require('@/common/images/icon/26_1.png'),
  qrcordManage: require('@/common/images/icon/27.png'),
  qrcordManage_active: require('@/common/images/icon/27_1.png'),
  //涉河监控
  shessenlinfo: require('@/common/images/icon/21.png'),
  shessenlinfo_active: require('@/common/images/icon/21_1.png'),
  shpersonliable: require('@/common/images/icon/26.png'),
  shpersonliable_active: require('@/common/images/icon/26_1.png'),
  //知识库
  knowledgebase: require("@/common/images/icon/82.png"),
  knowledgebase_active: require("@/common/images/icon/82.png"),

  //安全监测
  sensor: require('@/common/images/icon/31.png'),
  sensor_active: require('@/common/images/icon/31_1.png'),
  drawstring: require('@/common/images/icon/32.png'),
  drawstring_active: require('@/common/images/icon/32_1.png'),
  waterlevelgauge: require('@/common/images/icon/33.png'),
  waterlevelgauge_active: require('@/common/images/icon/33_1.png'),
  raingauge: require('@/common/images/icon/34.png'),
  raingauge_active: require('@/common/images/icon/34_1.png'),
  rain: require('@/common/images/icon/35.png'),
  rain_active: require('@/common/images/icon/35_1.png'),
  Videomonitor: require('@/common/images/icon/36.png'),
  Videomonitor_active: require('@/common/images/icon/36_1.png'),
  //防汛管理
  earlyWarning: require('@/common/images/icon/45.png'),
  earlyWarning_active: require('@/common/images/icon/45_1.png'),
  beonduty: require('@/common/images/icon/41.png'),
  beonduty_active: require('@/common/images/icon/41_1.png'),
  controlpoint: require('@/common/images/icon/42.png'),
  controlpoint_active: require('@/common/images/icon/42_1.png'),
  reserveplan: require('@/common/images/icon/43.png'),
  reserveplan_active: require('@/common/images/icon/43_1.png'),
  managementsystem: require('@/common/images/icon/44.png'),
  managementsystem_active: require('@/common/images/icon/44_1.png'),
  funds: require('@/common/images/icon/45.png'),
  funds_active: require('@/common/images/icon/45_1.png'),
  //巡查维护
  inspectionplan: require('@/common/images/icon/51.png'),
  inspectionplan_active: require('@/common/images/icon/51_1.png'),
  hiddenmanagement: require('@/common/images/icon/52.png'),
  hiddenmanagement_active: require('@/common/images/icon/52_1.png'),
  //应急管理
  emergencysupplies: require('@/common/images/icon/61.png'),
  emergencysupplies_active: require('@/common/images/icon/61_1.png'),
  emergencydnill: require('@/common/images/icon/62.png'),
  emergencydnill_active: require('@/common/images/icon/62_1.png'),
  //安全保障
  repair: require('@/common/images/icon/71.png'),
  repair_active: require('@/common/images/icon/71_1.png'),
  //暗访督查
  supervision: require('@/common/images/icon/81.png'),
  supervision_active: require('@/common/images/icon/81_1.png'),
}

export default {
    towMenu
}
